<template>
  <div class="dynamicalEnergyPage">
    <AnalysisHead @getActiveTime="getActiveTime" />
    <div class="analysis ashComWrap">
      <div class="comTitle">
        <h4>用能分析</h4>
      </div>
      <div class="comContentBox comFlex">
        <div class="overview secondAshComWrap">
          <div class="comTitle">
            <h4>总览</h4>
          </div>
          <div class="comContentBox comFlex">
            <div class="overviewWrap">
              <div class="row">
                <div class="topBox">
                  <AnalysisOverview :overviewData="overviewData[0]" />
                </div>
                <div class="bottomBox">
                  <PublicEcharts
                    :id="'overviewCharts'"
                    :chartsData="overviewData[0].dataArr"
                    :type="'scaleCharts'"
                  />
                </div>
              </div>
              <div class="row1">
                <div class="leftBox">
                  <AnalysisOverview :overviewData="overviewData[1]" />
                </div>
                <div class="rightBox">
                  <PublicEcharts
                    :id="'overvieScale'"
                    :chartsData="{ overvieScale }"
                    :options="dealRingData(overvieScale)"
                    usePropsOptions
                  />
                </div>
              </div>
            </div>
            <div class="ringWrap">
              <el-radio-group
                v-model="overviewActive"
                size="mini"
                style="width: 100%; text-align: center"
                @change="getEquipmentEnergy"
              >
                <el-radio-button
                  :label="v.value"
                  v-for="v in overviewList"
                  :key="v.value"
                  >{{ v.name }}</el-radio-button
                >
              </el-radio-group>
              <div style="width: 100%; height: 85%">
                <PublicEcharts
                  :id="'ringCharts'"
                  :chartsData="overviewRingList"
                  :type="'ringChart'"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="ecTop secondAshComWrap">
          <div class="comTitle">
            <h4>用电TOP5</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'ecTop'"
              :chartsData="ecTopList"
              :type="'horizontalBar'"
            />
          </div>
        </div>
        <div class="powerSaving secondAshComWrap">
          <div class="comTitle">
            <h4>节电TOP5</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'powerSaving'"
              :chartsData="powerSavingList"
              :type="'horizontalBar'"
            />
          </div>
        </div>
      </div>
    </div>
    <AnalysisTwoChart
      :leftCharts="hoursCharts"
      :rightCharts="ecTrend"
      :leftTitle="'24小时用能分析'"
      :rightTitle="rightTitle"
    />
    <AnalysisTable
      :title="'用电详情表'"
      :tabHead="tabHead"
      :tableData="tableData"
      :excelTitle="excelTitle"
      :showDownload="judgeAuthority('zixitong:dongli:dynamicalEnergy:export')"
    />
  </div>
</template>

<script>
import api from "@/api";
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import PublicEcharts from "@/components/PublicEcharts";
import AnalysisOverview from "@/components/fenxizujian/AnalysisOverview";
import AnalysisTwoChart from "@/components/fenxizujian/AnalysisTwoChart";
import AnalysisTable from "@/components/fenxizujian/AnalysisTable";
import { dateFtt, judgeAuthority, handleNumDecimal } from "@/assets/js/utils";
export default {
  components: {
    AnalysisHead,
    PublicEcharts,
    AnalysisOverview,
    AnalysisTwoChart,
    AnalysisTable,
  },
  data() {
    return {
      ecTopList: {
        name: "用电",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      powerSavingList: {
        name: "节电",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      overviewList: [
        { name: "全部", value: "直梯,扶梯,加速带" },
        { name: "直梯", value: "直梯" },
        { name: "扶梯", value: "扶梯" },
        { name: "加速带", value: "加速带" },
      ],
      overviewActive: "直梯,扶梯,加速带",
      overviewRingList: {
        unit: "kw·h",
        dataArr: [],
      },
      overviewData: [
        {
          title: "总能耗",
          num: null,
          unit: "kw·h",
          yoy: "",
          mom: "",
          dataArr: {
            dataArr: [
              {
                name: "运行用电",
                value: null,
                unit: "kw·h",
              },
              {
                name: "等待用电",
                value: null,
                unit: "kw·h",
              },
            ],
          },
        },
        {
          title: "节电",
          num: null,
          unit: "kw·h",
          yoy: "",
          mom: "",
          dataArr: {
            name: "节电率",
            value: null,
          },
        },
      ],
      overvieScale: {},
      hoursCharts: {
        unit: "kw·h",
        xData: [],
        dataArr: [],
      },
      ecTrend: {
        unit: "kw·h",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      rightTitle: "",
      excelTitle: "",
      tabHead: [],
      tableData: [],
      activeTime: {},
      pubParams: {},
    };
  },
  methods: {
    judgeAuthority,
    getTableHeade() {
      this.tabHead = [
        { label: "时间", prop: "time" },
        {
          label: `总用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "ecValue",
        },
        {
          label: `扶梯用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "escalatorValue",
        },
        {
          label: `直梯用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "straightLadderValue",
        },
        {
          label: `加速带用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "accelerationBeltValue",
        },
        {
          label: `等待用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "waitValue",
        },
        {
          label: `运行用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "runValue",
        },
        {
          label: `发电表/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "scValue",
        },
      ];
    },
    getActiveTime(val) {
      this.$store.commit("SET_LOADING", true);
      this.activeTime = val;
      this.getTableHeade();
      this.excelTitle = `动力系统分析-${
        val.timeValue ? val.timeValue : "全部"
      }`;
      this.pubParams = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        systemType: "动力系统",
        assetType: "动力系统",
        type: this.activeTime.type,
        date: this.activeTime.timeValue,
      };
      this.getOverview();
      this.getEquipmentEnergy();
      this.getElectricitySaving("ec");
      this.getElectricitySaving("sc");
      this.getFourEC();
      this.getECData();
      this.getEcTable();
      if (val.type == "MONTH") {
        this.rightTitle = "每日用电排行";
      } else if (val.type == "YEAR") {
        this.rightTitle = "每月用电排行";
      } else {
        this.rightTitle = "每年用电排行";
      }

      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },
    dealRingData(data = {}) {
      const { value } = data;
      let optionDefault = {
        title: {
          text: "节电率",
          x: "center",
          y: "40%",
          textStyle: {
            color: "#999",
            fontSize: 12,
            align: "center",
          },
          subtext: `${value}%`,
          subtextStyle: {
            fontSize: 14,
            color: "#999",
          },
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        color: ["#28CCCB", "#F4F6F7"],
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            cursor: "default",
            data: [
              {
                name: "负荷率",
                value,
                emphasis: {
                  disabled: true,
                },
              },
              {
                name: "总数",
                value: 100 - value,
                emphasis: {
                  disabled: true,
                },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: false,
            },
          },
        ],
      };
      return optionDefault;
    },

    async getOverview() {
      this.overviewData = [
        {
          title: "总能耗",
          num: null,
          unit: "kw·h",
          yoy: "",
          mom: "",
          dataArr: {
            dataArr: [
              {
                name: "运行用电",
                value: null,
                unit: "kw·h",
              },
              {
                name: "等待用电",
                value: null,
                unit: "kw·h",
              },
            ],
          },
        },
        {
          title: "节电",
          num: null,
          unit: "kw·h",
          yoy: "",
          mom: "",
          dataArr: {
            name: "节电率",
            value: null,
          },
        },
      ];
      let res = await api.DynamicalEnergyOverview(this.pubParams);
      if (res && res.data.code == 200) {
        this.overviewData = Array.from(res.data.data).map((item) => ({
          title: item.name,
          num: handleNumDecimal(
            item.values.value > 10000
              ? item.values.value / 10000
              : item.values.value
          ),
          unit:
            item.values.value > 10000
              ? "万" + item.values.unit
              : item.values.unit,
          yoy: item.values.charts.find((v) => {
            return v.name == "同比";
          })?.value,
          mom: item.values.charts.find((v) => {
            return v.name == "环比";
          })?.value,
          dataArr:
            item.name == "总能耗"
              ? {
                  dataArr: [
                    {
                      name: "运行用电",
                      value: item.values.charts.find((v) => {
                        return v.name == "运行用电";
                      })?.value,
                      unit: "kw·h",
                    },
                    {
                      name: "等待用电",
                      value: item.values.charts.find((v) => {
                        return v.name == "等待用电";
                      })?.value,
                      unit: "kw·h",
                    },
                  ],
                }
              : {
                  name: "节电率",
                  value: Number(
                    item.values.charts
                      .find((v) => {
                        return v.name == "节电率";
                      })
                      ?.value.slice(0, -1)
                  ),
                },
        }));
        this.overvieScale = this.overviewData[1].dataArr;
      }
    },

    async getEquipmentEnergy() {
      this.overviewRingList.dataArr = [];
      let obj = Object.assign(
        {},
        { deviceTypes: this.overviewActive },
        this.pubParams
      );
      let res = await api.DynamicalEnergyEquipmentEnergy(obj);
      if (res && res.data.code == 200) {
        this.overviewRingList.dataArr = res.data.data;
      }
    },

    async getElectricitySaving(type) {
      let str = type == "ec" ? "ecTopList" : "powerSavingList";
      let obj = Object.assign(
        {
          energyType: type,
          deviceTypes: "直梯,扶梯,加速带",
        },
        this.pubParams
      );
      this[str].xData = [];
      this[str].yData = [];
      let res = await api.DynamicalEnergyElectricitySaving(obj);
      if (res && res.data.code == 200) {
        res.data.data.slice(0, 5).map((v) => {
          this[str].xData.push(v.value);
          this[str].yData.push(v.name);
        });
      }
    },

    async getFourEC() {
      this.hoursCharts.xData = [];
      this.hoursCharts.dataArr = [
        { name: "运行", key: "RC", data: [] },
        { name: "等待", key: "WC", data: [] },
      ];
      let obj = Object.assign(
        {},
        { energyType: "ec", deviceTypes: "直梯,扶梯,加速带" },
        this.pubParams
      );
      let res = await api.DynamicalEnergyFourEC(obj);
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.map((v) => {
          this.hoursCharts.xData.push(v.name + "时");
          arr.push(v.values);
        });
        arr.map((v) => {
          v.map((j) => {
            this.hoursCharts.dataArr.map((item) => {
              if (j.name == item.key) {
                item.data.push(j.value);
              }
            });
          });
        });
      }
    },

    async getECData() {
      this.ecTrend.xData = [];
      this.ecTrend.dataArr = [];
      this.$store
        .dispatch("publicGetECData", { params: this.pubParams })
        .then((res) => {
          this.ecTrend.xData = res.xData;
          this.ecTrend.dataArr = res.dataArr;
        });
    },

    async getEcTable() {
      this.tableData = [];
      let obj = Object.assign(
        {},
        { deviceTypes: "直梯,扶梯,加速带" },
        this.pubParams
      );
      let res = await api.DynamicalEcTable(obj);
      if (res && res.data.code == 200) {
        this.tableData = Array.from(res.data.data).map((item) => ({
          time:
            this.activeTime.type == "MONTH"
              ? dateFtt("dd日", new Date(item.ts))
              : this.activeTime.type == "YEAR"
              ? dateFtt("MM月", new Date(item.ts))
              : dateFtt("yyyy年", new Date(item.ts)),
          ecValue: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.ecValue
              : item.ecValue / 10000
          ),
          escalatorValue: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.escalatorValue
              : item.escalatorValue / 10000
          ),
          straightLadderValue: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.straightLadderValue
              : item.straightLadderValue / 10000
          ),
          accelerationBeltValue: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.accelerationBeltValue
              : item.accelerationBeltValue / 10000
          ),
          waitValue: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.waitValue
              : item.waitValue / 10000
          ),
          runValue: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.runValue
              : item.runValue / 10000
          ),
          scValue: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.scValue
              : item.scValue / 10000
          ),
        }));
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.dynamicalEnergyPage {
  width: 100%;
  overflow: auto;
  .comFlex {
    @include setFlexBetween;
  }
  .analysis {
    width: $innerWidth;
    height: 450px;
    margin: 0 auto;
    .overview {
      width: 50%;
      // background: salmon;
    }
    .ecTop,
    .powerSaving {
      width: 25%;
    }
    .overviewWrap,
    .ringWrap {
      width: 50%;
      height: 100%;
    }
    .overviewWrap {
      // background: sandybrown;
      .row {
        width: 100%;
        height: 55%;
        .topBox {
          width: 90%;
          margin: 0 auto;
          height: 60%;
        }
        .bottomBox {
          width: 90%;
          margin: 0 auto;
          height: 40%;
        }
      }
      .row1 {
        width: 90%;
        height: 45%;
        margin: 0 auto;
        // background: salmon;
        @include setFlexCenter;
        .leftBox {
          width: 63%;
          height: 100%;
        }
        .rightBox {
          width: 37%;
          height: 100%;
        }
      }
    }
  }
}
</style>
